module.exports = __webpack_public_path__ + "img/attachment-01.2140d1cd.svg";